import {Component, inject} from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-privacy-notice-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    RouterLink
  ],
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.css'
})
export class PrivacyNoticeDialogComponent {

  private dialogRef = inject(MatDialogRef<PrivacyNoticeDialogComponent>);

  acknowledge() {
    this.dialogRef.close(true);
  }
}
